import { TemplateResult, html } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';

/**
 * The PcPodcastIframeWrapper component
 * @element pc-podcast-iframe-wrapper
 */
@customElement('pc-podcast-iframe-wrapper')
export class PcPodcastIframeWrapper extends OutlineElement {
  /**
   * remove shadowDOM
   */
  createRenderRoot() {
    return this;
  }

  connectedCallback(): void {
    super.connectedCallback();
    setTimeout(() => this.setLabel(), 300);
  }

  setLabel() {
    const frame = this.querySelector('iframe');

    if (frame && frame.nodeName === 'IFRAME') {
      frame.setAttribute('aria-label', 'podcast player');
    }
  }

  render(): TemplateResult {
    return html``;
  }
}
